import React from 'react';
import VideoCastView from './VideoCastView';

export default function VideoCastEdit(props: any) {
  return <VideoCastView {...props} isEditMode />;
}
